import { IContentSource } from "../../../domain/drawing";
import { AbstractSource } from "../../drawing";

export class FormatPreviewSource extends AbstractSource {
  constructor(getToken: () => string, public id: number) {
    super(getToken);
    if (id === undefined) {
      throw new Error("id is empty!!!");
    }
  }

  protected getSource(): string {
    // TODO:キャッシュするならここで実装する.とりあえずはソース文字列を返す.
    const url = "/api/format/" + this.id + "/view?token=" + this.token;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IContentSource {
    return new FormatPreviewSource(
      this._getToken,
      this.id
    );
  }
}
